// src/features/business-functions/hooks/useCreateWorkspaceTable.js
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { buildNewFormStudioRoute } from '../utils/businessFunctionRoutes';

/**
 * Navigates to the form studio for a workspace (campaign).
 */
export default function useCreateWorkspaceTable(
  accountId,
  workspaceId,
  { canCreate = true } = {}
) {
  const navigate = useNavigate();

  const createTable = useCallback(() => {
    if (!accountId || !workspaceId || !canCreate) return;

    navigate(buildNewFormStudioRoute(accountId, workspaceId));
  }, [accountId, canCreate, navigate, workspaceId]);

  return { createTable };
}
